export default __webpack_public_path__ + "static/media/unionPay.fcec781f.svg";